import { apiClient } from "./api";

export function getCentreData(centre: string | number, type: string, year?: string | number, split?: boolean, date?: string | number) {
  return apiClient.get(`/centres/${centre}/chart`, { params: { type, year, split, date } })
}

export function getCentreTestsData(centre: string | number, year?: string | number) {
  return getCentreData(centre, 'tests', year)
}